export const LOAD_LOCATION_TITLE = 'LOAD_LOCATION_TITLE';
export const UPDATE_LOCATION_TITLE = 'UPDATE_LOCATION_TITLE';
export const HIDE_MENU = "HIDE_MENU";
export const SCROLL_CHANGE = "SCROLL_CHANGE";
export const SET_DEBUGGING = "SET_DEBUGGING";
export const SET_TRANSPARENT_FOOTER = "SET_TRANSPARENT_FOOTER";
export const SET_IS_EXTRANET_APP = "SET_IS_EXTRANET_APP"

export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_NB_TOTAL_RESULTS = "SET_NB_TOTAL_RESULTS";

export const DEFAULT_PAGE_SIZE = 20;